import PropTypes from 'prop-types';

export const CompanyCodePropTypes = PropTypes.shape({
  branch: PropTypes.string.isRequired,
  businessCode: PropTypes.string.isRequired,
  businessDesc: PropTypes.string.isRequired,
  businessUnit: PropTypes.string.isRequired,
  businessUnitDesc: PropTypes.string.isRequired,
  cc: PropTypes.string.isRequired,
  connection: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  countryCode: PropTypes.string.isRequired,
  desc: PropTypes.string.isRequired,
  enabledFlag: PropTypes.string.isRequired,
  enabledObligations: PropTypes.string.isRequired,
  fullDesc: PropTypes.string.isRequired,
  functionalCurrency: PropTypes.string.isRequired,
  lastUpdated: PropTypes.string,
  legalDesc: PropTypes.string.isRequired,
  legalEntity: PropTypes.string.isRequired,
  statCalc: PropTypes.string.isRequired,
  statCurrency: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  subledgerFlag: PropTypes.string.isRequired,
  taxCurrency: PropTypes.string.isRequired,
});

export const ConnectionPropTypes = PropTypes.shape({
  periodName: PropTypes.string.isRequired,
  connName: PropTypes.string.isRequired,
  connType: PropTypes.string.isRequired,
  enabledFlag: PropTypes.string,
  esFlag: PropTypes.string,
  dataSource: PropTypes.string,
  inboundFormat: PropTypes.string,
  outboundFormat: PropTypes.string,
  inboundName: PropTypes.string,
  outboundName: PropTypes.string,
  inboundFolderName: PropTypes.string,
  outboundFolderName: PropTypes.string,
  generateJeFlag: PropTypes.string,
  bsmJeFlag: PropTypes.string,
  sourceFolder: PropTypes.string,
  deleteRawTbData: PropTypes.string,
  label: PropTypes.string,
  dblink: PropTypes.string,
  sapJcoAshost: PropTypes.string,
  sapJcoSysnr: PropTypes.string,
  sapJcoClient: PropTypes.string,
  sapJcoR3name: PropTypes.string,
  sapJcoUser: PropTypes.string,
  sapJcoPassword: PropTypes.string,
  sapJcoLang: PropTypes.string,
  sapJcoSessionId: PropTypes.string,
  connectionKey: PropTypes.string,
  notificationEmail: PropTypes.string,
  lcdMcCloseStart: PropTypes.string,
  lcdMcCloseEnd: PropTypes.string,
  lcdQcCloseStart: PropTypes.string,
  lcdQcCloseEnd: PropTypes.string,
  lcdYeCloseStart: PropTypes.string,
  lcdYeCloseEnd: PropTypes.string,
  scheduleType: PropTypes.string,
  runInterval: PropTypes.string,
  jobInterval: PropTypes.string,
});

export const ConnectionsPropTypes = PropTypes.arrayOf(ConnectionPropTypes.isRequired).isRequired;
